import React from "react";
import Marquee from "react-fast-marquee";

const offerText = "Buy 2 Get 1 Free - Get \u20b9100 OFF on your first order - Free shipping pan-India - Cash on Delivery available - Easy 7-day returns -";

const OfferMarquee = () => (
  <div className="bg-cynos-red py-2 text-white" data-testid="top-offer-marquee">
    <Marquee gradient={false} speed={45} className="font-mono text-xs uppercase tracking-[0.2em]">
      <span className="mx-8">{offerText}</span>
      <span className="mx-8">{offerText}</span>
    </Marquee>
  </div>
);

export default OfferMarquee;
